export default __webpack_public_path__ + "static/media/gea.c01f0db3.svg";